/**
 * Determines if we are running from the app
 * @returns {boolean}
 */
export const isBrekzApp = () => {
    return document.cookie.includes("request_from_brekz_app=true");
}

export const isIos = () => {
    return /iPad|iPhone|iPod/.test(navigator.userAgent)
}
